'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Drawer: ()=>Drawer
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_vaul_namespaceObject = require("vaul");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Heading_index_cjs_namespaceObject = require("../Heading/index.cjs");
const external_IconButton_index_cjs_namespaceObject = require("../IconButton/index.cjs");
const external_ScrollArea_index_cjs_namespaceObject = require("../ScrollArea/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_Drawer_variants_cjs_namespaceObject = require("./Drawer.variants.cjs");
const visuallyHiddenClass = 'sr-only';
function Drawer({ children, description, footer, headingCustomNode, headingIconName, headingRightNode, headingText, open, defaultOpen, showCloseButton = true, showDragHandle = true, title, triggerNode, classNames, onNaturalClose, onOpenChange, ...props }) {
    const { overlaySlot, headingSlot, headingSlotLeft, headingRightNodeSlot, closeButtonSlot, headingTextSlot, headingIconSlot, bodySlot, scrollAreaSlot, contentSlot, handlePositionSlot, handleSlot, footerSlot } = (0, external_Drawer_variants_cjs_namespaceObject.drawerVariants)({
        showDragHandle,
        customBody: children ? 'string' != typeof children : false,
        customFooter: !!footer,
        customHeader: !!headingCustomNode,
        showCloseButton,
        useSnapping: !!props.snapPoints,
        size: 'bottom' !== props.direction && void 0 !== props.direction ? 'sm' : props.size,
        hasHeadingText: !!headingText,
        ...props
    });
    const contentSlotClass = (0, index_cjs_namespaceObject.cn)(contentSlot(), classNames?.contentSlot);
    const [snap, setSnap] = external_react_default().useState(props.snapPoints?.[0] || null);
    const handleOpenChange = (open)=>{
        if (onNaturalClose && !open) onNaturalClose();
        onOpenChange?.(open);
    };
    const handleClose = ()=>{
        if (onNaturalClose) onNaturalClose();
        onOpenChange?.(false);
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_vaul_namespaceObject.Drawer.Root, {
        ...props,
        open: open,
        onOpenChange: handleOpenChange,
        defaultOpen: void 0 === open ? defaultOpen : false,
        ...(0, index_cjs_namespaceObject.cleanProps)({
            activeSnapPoint: snap,
            setActiveSnapPoint: setSnap
        }, [
            'activeSnapPoint',
            'setActiveSnapPoint'
        ]),
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Trigger, {
                asChild: true,
                children: triggerNode
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_vaul_namespaceObject.Drawer.Portal, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Overlay, {
                        className: overlaySlot()
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_vaul_namespaceObject.Drawer.Content, {
                        className: contentSlotClass,
                        children: [
                            showDragHandle && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: handlePositionSlot(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Handle, {
                                    className: handleSlot()
                                })
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: headingSlot(),
                                children: [
                                    headingCustomNode ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Title, {
                                        className: "w-full",
                                        children: headingCustomNode
                                    }) : headingText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                                className: headingSlotLeft(),
                                                children: [
                                                    headingIconName && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                                                        iconName: headingIconName,
                                                        size: "24",
                                                        className: headingIconSlot()
                                                    }),
                                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Title, {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Heading_index_cjs_namespaceObject.Heading, {
                                                            as: "h4",
                                                            className: headingTextSlot(),
                                                            children: headingText
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                                className: headingRightNodeSlot(),
                                                children: headingRightNode
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                                className: "flex-1"
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Title, {
                                                asChild: true,
                                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                                                    className: visuallyHiddenClass,
                                                    children: title
                                                })
                                            })
                                        ]
                                    }),
                                    showCloseButton && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                        className: closeButtonSlot(),
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Close, {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_IconButton_index_cjs_namespaceObject.IconButton, {
                                                iconName: "close",
                                                type: "primary",
                                                shadow: true,
                                                size: "md",
                                                "aria-label": "Close Drawer",
                                                emphasis: "bold",
                                                onClick: handleClose
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ScrollArea_index_cjs_namespaceObject.ScrollArea, {
                                className: scrollAreaSlot(),
                                drawerBody: true,
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                        className: bodySlot(),
                                        children: [
                                            description && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Description, {
                                                className: visuallyHiddenClass,
                                                children: description
                                            }),
                                            !description && !children && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_vaul_namespaceObject.Drawer.Description, {
                                                className: visuallyHiddenClass,
                                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                                                    className: visuallyHiddenClass,
                                                    children: "No content available"
                                                })
                                            }),
                                            'string' == typeof children ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                                                textStyle: "body2",
                                                className: "px-4",
                                                children: children
                                            }) : children
                                        ]
                                    }),
                                    footer && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                        className: footerSlot(),
                                        children: footer
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.Drawer = __webpack_exports__.Drawer;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Drawer"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
